export enum SpecialFacilityAccess {
  WheelchairAccessible = 'Wheelchair Accessible',
  SameDayAppointment = 'Same Day Appointment/Walk-Ins Accepted',
  ExtendedWeekendHours = 'Extended or Weekend Hours',
  TeenClinicHours = 'Teen Clinic/Hours Available',
}
